import { render, staticRenderFns } from "./CheckoutButton.vue?vue&type=template&id=37102ccf&scoped=true&lang=pug"
import script from "./CheckoutButton.vue?vue&type=script&lang=js"
export * from "./CheckoutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37102ccf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37102ccf')) {
      api.createRecord('37102ccf', component.options)
    } else {
      api.reload('37102ccf', component.options)
    }
    module.hot.accept("./CheckoutButton.vue?vue&type=template&id=37102ccf&scoped=true&lang=pug", function () {
      api.rerender('37102ccf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/CheckoutButton.vue"
export default component.exports